import React, { useEffect, useState } from "react";
import { Download, X, Share, Plus } from "lucide-react";

export default function InstallButton({ className = "" }) {
  const [deferred, setDeferred] = useState(null);
  const [showHelp, setShowHelp] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) { setInstalled(true); return; }
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;

  const click = async () => {
    if (deferred) {
      deferred.prompt();
      try { await deferred.userChoice; } catch { /* */ }
      setDeferred(null);
    } else {
      setShowHelp(true);
    }
  };

  return (
    <>
      <button data-testid="install-app-btn" onClick={click}
        className={`mono-label flex items-center gap-1.5 border border-cyan-400/50 text-cyan-300 px-4 py-2 rounded-full hover:bg-cyan-400/10 hover:shadow-[0_0_18px_rgba(0,240,255,0.35)] transition-all ${className}`}>
        <Download size={13} /> Install App
      </button>

      {showHelp && (
        <div className="fixed inset-0 z-[80] grid place-items-center bg-black/70 backdrop-blur-sm px-6" data-testid="install-help" onClick={() => setShowHelp(false)}>
          <div className="glass rounded-2xl p-7 max-w-sm w-full border border-cyan-400/30 relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setShowHelp(false)} className="absolute top-4 right-4 text-slate-400 hover:text-white"><X size={18} /></button>
            <Download className="text-cyan-400" size={30} />
            <h2 className="font-display text-xl font-bold mt-4">Get ARCHON on your phone</h2>
            <div className="mt-5 space-y-4 text-sm text-slate-300">
              <div>
                <p className="mono-label mb-1">IPHONE / IPAD (SAFARI)</p>
                <p className="flex items-center gap-1.5 flex-wrap">Tap <Share size={15} className="text-cyan-300 inline" /> <span className="text-slate-400">Share</span> → <span className="text-cyan-300">Add to Home Screen</span></p>
              </div>
              <div>
                <p className="mono-label mb-1">ANDROID (CHROME)</p>
                <p className="flex items-center gap-1.5 flex-wrap">Tap ⋮ menu → <Plus size={14} className="text-cyan-300 inline" /> <span className="text-cyan-300">Install app / Add to Home screen</span></p>
              </div>
              <div>
                <p className="mono-label mb-1">DESKTOP (CHROME / EDGE)</p>
                <p>Click the install icon in the address bar → <span className="text-cyan-300">Install</span>.</p>
              </div>
            </div>
            <p className="text-[0.7rem] text-slate-600 mt-5">It launches full-screen with its own icon, just like a native app.</p>
          </div>
        </div>
      )}
    </>
  );
}
